import { computed } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { DoctorDocumentReviewer } from '@/router/permissionsGroupByRouter'

/**
 * D112: quem é Editor de Documentação (ou acima) em alguma empresa decide, seleciona lote, usa os
 * atalhos e mexe no Kanban. O Leitor vê tudo em leitura. O backend confere de novo em cada rota.
 */
export function useDocumentReviewAccess() {
  const permissionsStore = usePermissionsStore()
  const canReview = computed(() =>
    DoctorDocumentReviewer.some((authorization) =>
      permissionsStore.checkAnyRessources(authorization)
    )
  )
  return { canReview }
}
